import React from 'react'
import { resolvePatronIdentity, subjectTypeLabel, subjectTypeBadgeClass, clubOrVisitorIdLine } from '../../../utils/patronIdentity'

/**
 * Table cell: master profile / patron id primary; member or visitor id secondary.
 */
export default function PatronIdentityCell({ row }) {
  const id = resolvePatronIdentity(row)
  const secondary = clubOrVisitorIdLine(id)

  return (
    <div>
      <div className="flex items-center gap-1.5 flex-wrap">
        <span className={`inline-flex px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase ${subjectTypeBadgeClass(id.subject_type)}`}>
          {subjectTypeLabel(id.subject_type)}
        </span>
        <span className="font-mono text-sm">{id.patron_id || '—'}</span>
      </div>
      {id.master_profile_id && id.patron_id !== id.master_profile_id && (
        <div className="text-xs text-gray-500 mt-0.5 font-mono">MP {id.master_profile_id}</div>
      )}
      {id.profilesafe_profile_id && (
        <div className="text-xs text-gray-500 mt-0.5 font-mono">Profile {id.profilesafe_profile_id}</div>
      )}
      {secondary && (
        <div className="text-xs text-gray-500 mt-0.5">
          <span className="text-gray-400">{secondary.label}:</span>{' '}
          <span className="font-mono">{secondary.value}</span>
        </div>
      )}
      {id.member_name && (
        <div className="text-xs text-gray-600 mt-0.5 font-sans">{id.member_name}</div>
      )}
    </div>
  )
}
